"use strict";

exports.__esModule = true;
/**
 * Loads an external script asynchronously

 * @param {string} id Identifies the script, preventing the script to be loaded multiple times
 * @param {string} url Script src
 * @param {Document} doc Depencecy injection, defaults to document
 *
 * @returns {Promise<any>}
 */

exports.importer = function (id, url, doc) {
  if (doc === void 0) {
    doc = document;
  }

  return new Promise(function (resolve, reject) {
    // TODO: This exist-check is not safe. If importer is called two times
    // with the same id, the script might not be loaded but the following
    // still resolve.
    var exists = doc.getElementById(id);

    if (exists) {
      return resolve(exists);
    }

    var script = doc.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.addEventListener('load', function () {
      return resolve(script);
    }, false);
    script.addEventListener('error', function (err) {
      try {
        doc.body.removeChild(script);
      } catch (err2) {}

      reject(err);
    }, false);
    doc.body.appendChild(script);
  });
};